<div>
	@if (state$ | async; as state) {
		@switch (state) {
			@case (SetupWizardState.DASHBOARD) {
				<app-setup-wizard-dashboard></app-setup-wizard-dashboard>
			}
			@case (SetupWizardState.VIEW_PREVIOUS_JOBS) {
				<app-setup-wizard-view-previous-jobs></app-setup-wizard-view-previous-jobs>
			}
			@case (SetupWizardState.VIEW_PREVIOUS_JOB_DETAILS) {
				<app-setup-wizard-view-previous-job-details></app-setup-wizard-view-previous-job-details>
			}
			@case (SetupWizardState.UPLOAD_CSVS) {
				<app-setup-wizard-upload-csvs
					(onApplyToPreview)="onApplyToPreview($event)"
				></app-setup-wizard-upload-csvs>
			}
			@case (SetupWizardState.EDIT_STEPS_ACCOUNT) {
				<app-setup-wizard-edit-steps></app-setup-wizard-edit-steps>
			}
			@case (SetupWizardState.EDIT_STEPS_USERS) {
				<app-setup-wizard-edit-steps></app-setup-wizard-edit-steps>
			}
			@case (SetupWizardState.EDIT_STEPS_LOCATIONS) {
				<app-setup-wizard-edit-steps></app-setup-wizard-edit-steps>
			}
			@case (SetupWizardState.EDIT_STEPS_COURSES) {
				<app-setup-wizard-edit-steps></app-setup-wizard-edit-steps>
			}
			@case (SetupWizardState.EDIT_STEPS_SECTIONS) {
				<app-setup-wizard-edit-steps></app-setup-wizard-edit-steps>
			}
			@case (SetupWizardState.EDIT_STEPS_UNITS) {
				<app-setup-wizard-edit-steps></app-setup-wizard-edit-steps>
			}
			@case (SetupWizardState.EDIT_STEPS_LESSONS) {
				<app-setup-wizard-edit-steps></app-setup-wizard-edit-steps>
			}
			@case (SetupWizardState.EDIT_STEPS_ACTIVITIES) {
				<app-setup-wizard-edit-steps></app-setup-wizard-edit-steps>
			}
			@case (SetupWizardState.EDIT_STEPS_CONTENTS) {
				<app-setup-wizard-edit-steps></app-setup-wizard-edit-steps>
			}
			@case (SetupWizardState.PREVIEW_JOB) {
				<app-setup-wizard-preview-job></app-setup-wizard-preview-job>
			}
			@case (SetupWizardState.FINISHED) {
				<app-setup-wizard-finished></app-setup-wizard-finished>
			}
			@default {
				<h1>Unknown state: {{ state$ | async }}</h1>
			}
		}
	} @else {
		<nz-spin nzSimple nzSize="large"></nz-spin>
	}
</div>
